import React, { useEffect, useState } from 'react';

import { useParams } from 'hooks/useParams';
import { toJS } from 'mobx';
import { AnswerSurveyType, SurveyType } from 'models/Survey';
import { useNavigate } from 'react-router-dom';
import { SubmittedFormInstance } from 'services/submittedFormService';
import { SurveyServiceInstance } from 'services/surveyService';
import { AllErrors, NotFoundError } from 'types/Errors';

import AnswerSurveyView from './AnswerSurvey.view';
import {SubmittedFormType} from 'models/SubmittedForm';
import {QueryParams} from './AnswerSurvey.props';

const AnswerSurvey = (): JSX.Element => {
  const { surveyId, enrollmentFormId, email } = useParams() as QueryParams;
  const navigate = useNavigate();

  const [survey, setSurvey] = useState<SurveyType>();
  const [submittedForm, setSubmittedForm] = useState<SubmittedFormType>();

  useEffect(() => {
    if (!surveyId || !enrollmentFormId || !email) {
      navigate('/not-found');
    }

    (async () => {
      try {
        setSurvey(await SurveyServiceInstance.getById(surveyId).then(({body}) => body));
      } catch (error) {
        console.error(error);
        if (error instanceof NotFoundError) {
          navigate('/not-found');
        }
      }
      await SurveyServiceInstance.findSurvey(enrollmentFormId, email)
        .then(({body}) => setSubmittedForm(body))
        .catch(error => console.error(error));
    })();
  }, [surveyId, enrollmentFormId, email, navigate]);

  if (!survey) {
    return <h1>Loading...</h1>;
  }

  const onSubmit = async (answerForm: AnswerSurveyType): Promise<void> => {
    try {
      const message = await SubmittedFormInstance.saveSubmittedForm({
        answers: toJS(answerForm),
        enrollmentId: enrollmentFormId,
        submittedBy: atob(email)
      });
      return console.log(message);
    } finally {
      return navigate('/success');
    }
  };
  
  return <AnswerSurveyView
    currentSection=''
    survey={survey}
    submittedForm={submittedForm}
    // onSubmit={(e) => onSubmit(e.target.value)}
    onSubmit={onSubmit}
  />;
};

export default AnswerSurvey;
